import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AddPayoutAccountUKBankFormsProps,
  BankAccountType,
} from './AddPayoutAccountUKBankWrapper.types';
import Typography from '../../sharedComponents/Typography/Typography';
import styles from './add-payout-account-uk-bank-wrapper.module.scss';
import AddPayoutAccountIBANForm from '../AddPayoutAccountIBANForm/AddPayoutAccountIBANForm';
import AddPayoutAccountUKSortCodeForm from '../AddPayoutAccountUKSortCodeForm/AddPayoutAccountUKSortCodeForm';
import { CountryCode } from '../../utils/types/CountryCode/CountryCode.types';
import { CurrencyUnit } from '../../utils/types/Currency/Currency.types';

const AddPayoutAccountUKBankWrapper: React.FC<
  AddPayoutAccountUKBankFormsProps
> = ({ handleFormComplete, handleFormChange }) => {
  const { t } = useTranslation();
  const [accountType, setFormType] = useState<BankAccountType>(
    BankAccountType.LOCAL,
  );
  const renderForm = () => {
    switch (accountType) {
      case BankAccountType.LOCAL:
        return renderUKSortCodeForm();
      case BankAccountType.IBAN:
        return renderIbanForm();
      default:
        return <></>;
    }
  };

  const renderUKSortCodeForm = () => {
    return (
      <AddPayoutAccountUKSortCodeForm
        handleFormComplete={handleFormComplete}
        handleFormChange={handleFormChange}
      />
    );
  };
  const renderIbanForm = () => {
    return (
      <AddPayoutAccountIBANForm
        recipientCountry={CountryCode.UK}
        currency={CurrencyUnit.GBP}
        handleFormComplete={handleFormComplete}
        handleFormChange={handleFormChange}
        allowUK={true}
      />
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.accountTypeButtonWrapper}>
        <button
          className={
            styles[
              accountType === BankAccountType.LOCAL ? 'active' : 'inactive'
            ]
          }
          onClick={() => {
            setFormType(BankAccountType.LOCAL);
          }}
        >
          <Typography variant="label-1">
            {t('sunshine.label.sort_code')}
          </Typography>
        </button>
        <button
          className={
            styles[accountType === BankAccountType.IBAN ? 'active' : 'inactive']
          }
          onClick={() => {
            setFormType(BankAccountType.IBAN);
          }}
        >
          <Typography variant="label-1">{t('sunshine.label.iban')}</Typography>
        </button>
      </div>
      {renderForm()}
    </div>
  );
};

export default AddPayoutAccountUKBankWrapper;
